import React from 'react';
import './IQAC.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';
import { vcsList } from '../../data/vcData';

const IQAC = () => {
  const currentVC = vcsList[vcsList.length - 1];

  return (
    <div className="iqac-page">
      <Navbar />

      <div className="iqac-container">
        <div className="page-header">
          <h1>Internal Quality Assurance Cell (IQAC)</h1>
          <div className="header-underline"></div>
        </div>

        {/* ================= VC SECTION ================= */}
        <div className="iqac-vc-section-unique">
          <div className="iqac-vc-top-container-unique">
            <div className="iqac-vc-image-wrapper-unique">
              <img 
                src={currentVC.image} 
                alt={currentVC.name}
                className="iqac-vc-image-unique"
              />
            </div>
            <div className="iqac-vc-details-unique">
              <h3 className="iqac-vc-name-unique">{currentVC.name}</h3>
              <p className="iqac-vc-designation-unique">Hon'ble Vice Chancellor</p>
              {/* <p className="iqac-vc-period-unique">{currentVC.period}</p> */}
              <div className="iqac-dedication-message-unique">
                <p>
                  "Dedicated to Advancing Academic Excellence and Institutional Quality."
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ================= IQAC DIRECTOR SECTION ================= */}
        <div className="iqac-director-section-unique">
          <h2 className="iqac-director-title-unique">Director – IQAC</h2>

          <div className="iqac-director-card-unique">
            <div className="iqac-director-image-wrapper-unique">
              <img
                src="/person/RECTOR_NAIK.JPG"   // change this image
                alt="IQAC Director"
                className="iqac-director-image-unique"
              />
            </div>

            <div className="iqac-director-details-unique">
              <h3>Prof. N. T. K. Naik</h3>
              <p className="designation">
                Director, Internal Quality Assurance Cell
              </p>
              <p>Rayalaseema University, Kurnool</p>

              <div className="iqac-director-contact-unique">
                <p><strong>Email:</strong> drntknaik@gmail.com</p>
                <p><strong>Phone:</strong> 9440861023</p>
              </div>
            </div>
          </div>
        </div>

        {/* ================= ABOUT IQAC ================= */}
        <div className="iqac-about-full-section-unique">
          <h2 className="iqac-about-title-unique">
            About IQAC in Rayalaseema University
          </h2>

          <div className="iqac-about-content-unique">
            <p>
              The Internal Quality Assurance Cell (IQAC) at Rayalaseema University
              is a pivotal body that ensures and enhances the quality of
              education and academic excellence across all departments.
            </p>

            <div className="iqac-features-list-unique">
              <div className="iqac-feature-item-unique">
                <strong>Quality Benchmarking:</strong> Establishes academic and administrative quality standards.
              </div>

              <div className="iqac-feature-item-unique">
                <strong>Institutional Development:</strong> Promotes innovation, research and best practices.
              </div>

              <div className="iqac-feature-item-unique">
                <strong>Curriculum Review:</strong> Ensures updated and industry-aligned curriculum.
              </div>

              <div className="iqac-feature-item-unique">
                <strong>Faculty Development:</strong> Organizes training, workshops and seminars.
              </div>

              <div className="iqac-feature-item-unique">
                <strong>Student Support:</strong> Improves mentoring, counseling and career guidance.
              </div>

              <div className="iqac-feature-item-unique">
                <strong>Feedback System:</strong> Collects feedback for continuous improvement.
              </div>

              <div className="iqac-feature-item-unique">
                <strong>Accreditation:</strong> Leads NAAC, NIRF and ranking processes.
              </div>
            </div>

            <p className="iqac-commitment-unique">
              IQAC is committed to building a culture of excellence, accountability
              and continuous improvement in all academic and administrative
              activities of the University.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default IQAC;
